import {
    Settings, Sparkles
} from 'lucide-react';
import {
    DE_STUDIO_ENABLED
} from 'builders/destudio/config/featureFlags';

// App Builder moved to org level — no longer surfaced here.
const deStudioEntry = DE_STUDIO_ENABLED ? [{
    name: 'DE Studio',
    path: 'de-studio',
    icon: <Sparkles className="h-5 w-5" />
}] : [];

export default {
    name: 'Sub Organization',
    list: [
        ...deStudioEntry,
        {
            name: 'Settings',
            path: 'settings',
            icon: <Settings className="h-5 w-5" />
        },
    ]
};